// TODO
<template>
  <div class="app-container">
    <el-button
      size="small"
      type="primary"
      class="go-back"
      @click.stop="goBack()"
    >
      返回
    </el-button>

    <el-tabs v-model="activeIndex" type="border-card" v-tab-change:activeIndex="setActiveName">
      <!-- 活动详情 -->
      <el-tab-pane label="活动详情" name="0">
        <el-form
          ref="activityDetail"
          :model="activityDetail"
          label-width="80px"
          label-position="top"
          @submit.native.prevent="updateActivity"
        >
          <el-form-item label="标题" prop="ActivityTitle">
            <el-input v-model="activityDetail.ActivityTitle"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="ActivityProfile">
            <el-input v-model="activityDetail.ActivityProfile"></el-input>
          </el-form-item>
          <el-form-item label="活动类型" prop="ActivityType">
            <el-select v-model="activityDetail.ActivityType">
              <el-option label="现场抽奖" :value="0"></el-option>
              <el-option label="投票活动" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="活动发布区域" prop="ShowPlaceSelect">
            <el-select v-model="activityDetail.ShowPlaceSelect">
              <el-option label="首页推荐栏" :value="0"></el-option>
              <el-option label="首页轮播栏" :value="1"></el-option>
              <el-option label="全部" :value="2"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="封面" prop="ActivityTitle">
            <el-input v-model="activityDetail.ActivityTitle"></el-input>
          </el-form-item>
          <el-form-item label="标题" prop="ActivityTitle">
            <el-input v-model="activityDetail.ActivityTitle"></el-input>
          </el-form-item>
          <el-form-item label="标题" prop="ActivityTitle">
            <el-input v-model="activityDetail.ActivityTitle"></el-input>
          </el-form-item>
          <el-form-item label="标题" prop="ActivityTitle">
            <el-input v-model="activityDetail.ActivityTitle"></el-input>
          </el-form-item>
          <el-form-item label="标题" prop="ActivityTitle">
            <el-input v-model="activityDetail.ActivityTitle"></el-input>
          </el-form-item>
          <el-form-item label="标题" prop="ActivityTitle">
            <el-input v-model="activityDetail.ActivityTitle"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" native-type="submit"
              >更新</el-button
            >
          </el-form-item>
          <!-- <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="发布区域">
                <el-select v-model="activityDetail.region" style="width: 100%">
                  <el-option label="区域一" value="shanghai" />
                  <el-option label="区域二" value="beijing" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="活动标题">
            <el-input v-model="activityDetail.ActivityTitle" />
          </el-form-item>
          <el-form-item label="活动描述">
            <el-input
              v-model="activityDetail.ActivityProfile"
              type="textarea"
            />
          </el-form-item>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="开始时间">
                <el-date-picker
                  v-model="activityDetail.StartTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="结束时间">
                <el-date-picker
                  v-model="activityDetail.EndTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="上传封面"> -->
          <!-- <el-upload
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              list-type="picture"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件，且不超过500kb
              </div>
            </el-upload> -->
          <!-- </el-form-item>

          <el-form-item label="活动背景">
            <el-radio-group v-model="activityDetail.resource">
              <el-radio label="默认" />
              <el-radio label="自定义" />
            </el-radio-group>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" size="small" @click="onSubmit">
              保存
            </el-button>
            <el-button type="danger" size="small">删除</el-button>
          </el-form-item> -->
        </el-form>
      </el-tab-pane>

      <!-- 参与用户 -->
      <el-tab-pane label="参与用户" name="1">
        <!-- 顶部栏 -->
        <div class="topbar">
          <el-input
            v-model="search"
            size="small"
            placeholder=""
            prefix-icon="el-icon-search"
          />
        </div>
        <!-- 内容 -->
        <el-table
          :data="tableData"
          :header-cell-style="{ background: '#F5F7FA' }"
          style="width: 100%; margin-bottom: 20px"
        >
          <el-table-column prop="col1" label="用户编号" align="center" />
          <el-table-column prop="col2" label="用户Id" align="center" />
          <el-table-column prop="col3" label="宏云号" align="center" />
          <el-table-column prop="col4" label="电话号码" align="center" />
          <el-table-column prop="col5" label="参与时间" align="center" />
          <el-table-column label="操作" align="center" width="150">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="danger"
                @click.stop="deleteUser(scope.$index, scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination background layout="prev, pager, next" :total="100" />
      </el-tab-pane>

      <!-- 中奖用户 -->
      <el-tab-pane label="中奖用户" name="2">
        <!-- 顶部栏 -->
        <div class="topbar">
          <el-input
            v-model="search"
            size="small"
            placeholder=""
            prefix-icon="el-icon-search"
          />
        </div>
        <!-- 内容 -->
        <el-table
          :data="tableData2"
          :header-cell-style="{ background: '#F5F7FA' }"
          style="width: 100%; margin-bottom: 20px"
        >
          <el-table-column prop="col1" label="用户编号" align="center" />
          <el-table-column prop="col2" label="用户Id" align="center" />
          <el-table-column prop="col3" label="宏云号" align="center" />
          <el-table-column prop="col4" label="电话号码" align="center" />
          <el-table-column prop="col5" label="参与时间" align="center" />
          <el-table-column prop="col6" label="单位名称" align="center" />
          <el-table-column prop="col7" label="中奖奖项" align="center" />
          <el-table-column label="操作" align="center" width="150">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="danger"
                @click.stop="deleteUser(scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  getOne,
  updateActivity,
  getAward,
  addAward,
  updateAward,
  getUserList,
  deleteOrBackUser,
  getWinningUserList,
  setSpecialUser,
} from "@/api/mai/eventManagement/eventDetail";

export default {
  data() {
    return {
      search: "",
      activeIndex: "1", // 当前索引
      loading: false, // 加载开关
      searchValue: "", // 搜索内容
      totalCount: 0, // 列表总数
      pageSize: 10, // 单页条数
      currentPage: 1, // 当前页码
      tableData: [],
      tableData2: [],
      activityID: "",
      activityDetail: {},
      value1: 1,
    };
  },
  created() {
    this.activeIndex = this.$route.query.activeIndex;
    this.activityID = this.$route.query.activityID;
    this.refreshCurrentList();
  },
  methods: {
    /**
     * 返回上一页
     */
    goBack() {
      this.$router.go(-1);
    },
    /**
     * 刷新列表
     */
    refreshCurrentList() {
      switch (this.activeIndex) {
        case "0":
          this.getActivityDetail();
          break;
        case "1":
          this.getUserList();
          break;
      }
    },
    /**
     * 切换 tab
     */
    handleClick() {
      this.currentPage = 1;
      this.searchValue = "";
      this.refreshCurrentList();
    },
    /**
     * 获取活动详情
     */
    getActivityDetail() {
      const params = {
        activityID: this.activityID,
      };
      getOne(params).then((res) => {
        this.activityDetail = res.resultData;
        console.log(res.resultData);
      });
    },
    /**
     * 获取用户列表
     */
    getUserList() {
      const params = {
        activityID: this.activityID,
        sortName: "",
        sortOrder: "",
        pageNumber: "",
        pageSize: "",
        keyword: "",
        where: "",
      };
      getUserList(params).then((res) => {
        this.activityDetail = res.resultData;
        console.log(res.resultData);
      });
    },
    /**
     * 删除用户
     */
    deleteUser(index, row) {
      console.log(index, row);
      this.$confirm("是否删除该用户", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功",
          });
        })
        .catch(() => {
          this.$message("取消操作");
        });
    },
  },
};
</script>

<style scoped lang="scss"></style>
